module.exports = __webpack_public_path__ + "media/printed-materials/04-educator-high-school-qrg-19106619.jpg";